import { render, staticRenderFns } from "./InnerNewsList.vue?vue&type=template&id=5e7f5be2&"
import script from "./InnerNewsList.vue?vue&type=script&lang=js&"
export * from "./InnerNewsList.vue?vue&type=script&lang=js&"
import style0 from "./InnerNewsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports